import(/* webpackMode: "eager" */ "/vercel/path0/components/BlogCards.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/components/HeaderTitle.jsx");
import(/* webpackMode: "eager" */ "/vercel/path0/components/HomeBanner.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/components/Testimonals.jsx");
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
import(/* webpackMode: "eager" */ "/vercel/path0/public/adpicture.jpg");
import(/* webpackMode: "eager" */ "/vercel/path0/public/image_1.png");
import(/* webpackMode: "eager" */ "/vercel/path0/public/image_2.png");
import(/* webpackMode: "eager" */ "/vercel/path0/public/private_driver.png");
import(/* webpackMode: "eager" */ "/vercel/path0/public/purplegirl.jpg")